"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Collapse["default"];
  }
});
var _Collapse = _interopRequireDefault(require("./Collapse"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }